<template>
  <div class="c-step c-car-image-mobile">
    <div class="c-car-price-block">
      {{ messages["bofi_calculate_monthly_amount_car_info_price"] }}
      <div class="price">&euro; {{ carPriceFormatted }}</div>
    </div>
    <img alt="Image Url" :src="xcSession.car.imageUrl" />
  </div>
</template>
<script>

import * as Api from "../../api";
import * as BofiUtils from "../../utils";

export default {
  name: "CarPriceBlock",
  data() {
    return {
      messages: {
        bofi_calculate_monthly_amount_car_info_price: "Verkoopprijs",
      },
      xcSession: {
        car: {
          imageUrl: "",
          price: 2250,
        },
      }
    };
  },
  computed: {
    carPriceFormatted: function() {
      return BofiUtils.formatMoney(this.xcSession.car.price);
    },
  },
  beforeMount() {
    Api.Credit.getCalculationData()
      .then(data => {
        this.xcSession.car.imageUrl = data.imageUrl;
        this.xcSession.car.price = data.price;
      })
      .catch(() => {
        this.serverError = true;
      });
  },
};
</script>
